import { observer } from 'mobx-react';
import * as React from 'react';
import Main from '../BrowserSupport/Main';
import Notifications from '../Notifications';
import I18nTitle from '../Title/I18nTitle';
import { T } from '../Translations';
import Logo from '../components/Cutesies/Logo';
import MainNav from '../components/Platform/MainNav';

const ErrorLanding: React.FC = () => (
  <>
    <I18nTitle title="Error Landing" />
    <div>
      <MainNav />
      <Notifications />
      <div className="bg-cover bg-no-repeat bg-chevron">
        <Main id="main" className="min-h-[calc(100vh-150px)] flex justify-center items-center">
          <div className="flex justify-center items-center bg-white">
            <div className="text-center shadow p-12 rounded-md justify-items-center">
              <div className="flex justify-center items-center">
                <div className="h-[100%] w-[300px] items-center p-4">
                  <Logo />
                </div>
              </div>
              <div>
                <h1 className="text-2xl font-bold mb-4">
                  <T kind="Welcome to the Client Portal!" />
                </h1>
                <p className="text-gray-500">
                  <T kind="Please contact your learning and development team in order to access Client Portal features." />
                </p>
              </div>
            </div>
          </div>
        </Main>
      </div>
    </div>
  </>
);

export default observer(ErrorLanding);
